import QRCode from "react-qr-code";
import CopyLinkButton from "./CopyLinkButton";
import { createBackupLink } from "./utils/createBackupLink";
import { Button, Typography } from "@mui/material";
import isMobile from "is-mobile";

export function Backup(props: {changeToRestoreBackup: () => void}) {
    const link = createBackupLink() ?? '';

    return <div style={{ display: 'flex', flexDirection: 'column', gap: '40px', alignItems: 'center' }}>
        <Typography variant="h5">Copie o Link ou leia o QR code para fazer backup da sua carteira</Typography>
        <CopyLinkButton link={link} label="Salve esse link para backup" />
        <div style={{ height: "auto", margin: "0 auto", maxWidth: 256, width: "100%" }}>
            <QRCode
                size={256}
                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                value={link}
                viewBox={`0 0 256 256`}
            />
        </div>
        {isMobile() && (
            <Button variant="contained" onClick={props.changeToRestoreBackup}>
                Clique Aqui Para Fazer Recuperar Backup
            </Button>
        )}
    </div>
}